<template>
  <ListingBlock
    class="podcasts-block"
    :view="view"
    :docs="view.docs().filteredDocs"
    :docViewEventProperties="docViewEventProperties"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'

defineProps<{
  view: ListView
  docViewEventProperties?: (doc: ListItem) => Record<string, unknown>
}>()
</script>

<style lang="scss" scoped>
.podcasts-block {
  --listing-block-number-of-columns: 4;
}
</style>
